const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * REST exercise routes expect a plain UUID. GraphQL often returns a Relay global id
 * (base64 of `SomeType:uuid`). This returns the UUID segment for use in REST URLs.
 */
export function exerciseIdForRestApi(id: string | null | undefined): string | null {
  if (id == null || id === '') return null;
  const trimmed = id.trim();
  if (UUID_RE.test(trimmed)) return trimmed;

  try {
    const decoded = atob(trimmed);
    const colon = decoded.indexOf(':');
    if (colon >= 0) {
      const localId = decoded.slice(colon + 1);
      if (UUID_RE.test(localId)) return localId;
    }
  } catch {
    /* not base64 */
  }

  return null;
}
